export const getQueryParamValue = (name) => {
  var queryString = window.location.search.substring(1);
  var queryParams = queryString.split("&");

  for (var i = 0; i < queryParams.length; i++) {
    var param = queryParams[i].split("=");
    if (param[0] === name) {
      return decodeURIComponent(param[1]);
    }
  }
  // If the name was not found, return null
  return null;
};
